import { render, staticRenderFns } from "./StoreSelector.vue?vue&type=template&id=04d38a0b&scoped=true&"
import script from "./StoreSelector.vue?vue&type=script&lang=js&"
export * from "./StoreSelector.vue?vue&type=script&lang=js&"
import style0 from "./StoreSelector.vue?vue&type=style&index=0&id=04d38a0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d38a0b",
  null
  
)

export default component.exports